import { HubConnectionBuilder, LogLevel, HubConnectionState } from '@microsoft/signalr'
import Vue from 'vue'

export default {
    install(VueInstance) {

        // Bus reattivo con segnali counter — ogni incremento fa scattare i watcher
        const bus = new Vue({
            data() {
                return {
                    signals: {
                        programma:     0,
                        congregazioni: 0,
                        oratori:       0,
                        schemi:        0,
                    },
                    stato: 'disconnesso', // 'connesso' | 'riconnessione' | 'errore' | 'disconnesso'
                }
            }
        })

        VueInstance.prototype.$updaterHub = bus

        let connection    = null
        let reconnectTimer = null
        let reconnectDelay = 3000
        let currentPartition = null
        let visibilityAdded  = false

        // ── Helpers interni ──────────────────────────────────────────────

        const markDirty = (entity) => {
            if (entity in bus.signals) bus.signals[entity]++
        }

        const joinPartition = async () => {
            if (!connection || !currentPartition) return
            try {
                await connection.invoke('Join', currentPartition)
                console.log('[UpdaterHub] joined partition:', currentPartition)
            } catch (err) {
                console.warn('[UpdaterHub] Join fallito:', err)
            }
        }

        const scheduleReconnect = () => {
            clearTimeout(reconnectTimer)
            reconnectTimer = setTimeout(async () => {
                reconnectDelay = Math.min(reconnectDelay * 2, 60000)
                await bus.connect(currentPartition)
            }, reconnectDelay)
        }

        // ── API pubblica sul bus ─────────────────────────────────────────

        bus.connect = async (partition) => {
            if (!partition) return
            if (connection && connection.state !== HubConnectionState.Disconnected) return

            currentPartition = partition

            connection = new HubConnectionBuilder()
                .withUrl((process.env.VUE_APP_SERVER || '') + '/updater-hub', { withCredentials: false })
                .withAutomaticReconnect([2000, 5000, 10000, 30000])
                .configureLogging(LogLevel.Warning)
                .build()

            connection.on('EntityChanged', (entity) => {
                console.log('[UpdaterHub] EntityChanged:', entity)
                markDirty(entity)
            })

            connection.onreconnecting(() => {
                bus.stato = 'riconnessione'
            })

            connection.onreconnected(async () => {
                reconnectDelay = 3000
                bus.stato = 'connesso'
                await joinPartition()
            })

            connection.onclose((err) => {
                bus.stato = 'disconnesso'
                if (err) console.warn('[UpdaterHub] chiusa con errore:', err)
                connection = null
                scheduleReconnect()
            })

            try {
                await connection.start()
                await joinPartition()
                reconnectDelay = 3000
                bus.stato = 'connesso'
                console.log('[UpdaterHub] connesso')
            } catch (err) {
                bus.stato = 'errore'
                console.warn('[UpdaterHub] connessione fallita:', err)
                connection = null
                scheduleReconnect()
            }

            // Riconnetti quando la tab torna in primo piano
            if (!visibilityAdded) {
                visibilityAdded = true
                document.addEventListener('visibilitychange', () => {
                    if (document.visibilityState === 'visible') bus.ensureConnected()
                })
            }
        }

        bus.disconnect = async () => {
            clearTimeout(reconnectTimer)
            if (connection) {
                try { connection.onclose(null); await connection.stop() } catch {}
                connection = null
            }
            currentPartition = null
            bus.stato = 'disconnesso'
            console.log('[UpdaterHub] disconnesso')
        }

        bus.ensureConnected = async () => {
            if (!currentPartition) return
            if (!connection || connection.state === HubConnectionState.Disconnected) {
                connection = null
                await bus.connect(currentPartition)
            } else if (connection.state === HubConnectionState.Connected) {
                await joinPartition()
            }
        }
    }
}
